import React from 'react';
import { Control, Controller } from 'react-hook-form';
import { SettingsSelect } from '../../../../../../../BranchDetails/components/BranchComponents';
import { InputLabel, MenuItem } from '@material-ui/core';
import { AnswerOption, EditableQuestion } from '../../../../../../types';
import { cutLongText } from '../../../../../../../../helpers';
import { StyledQuestionFieldContainer } from '../../styles';
import { ErrorMessage } from '../../../../../../../Services/styled-components';

interface Props {
  control: Control<EditableQuestion>;
  answers: AnswerOption[];
}

const TriggeringAnswerEditor = ({ control, answers }: Props) => (
  <Controller
    control={control}
    name="answer_id"
    rules={{
      required: { value: true, message: 'Triggering answer is required' }
    }}
    render={({ field: { ref, ...field }, formState }) => (
      <StyledQuestionFieldContainer>
        <InputLabel>Triggering answer</InputLabel>
        <SettingsSelect {...field} value={field.value || ''}>
          {answers.map(answer => (
            <MenuItem value={answer._id}>{cutLongText(answer.value, 30)}</MenuItem>
          ))}
        </SettingsSelect>
        <ErrorMessage>{formState.errors.answer_id?.message}</ErrorMessage>
      </StyledQuestionFieldContainer>
    )}
  />
);

export default TriggeringAnswerEditor;
